// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"f90c1206","453":"3321c556","667":"5d1649e9","963":"c09f03e0"}[chunkId] + ".chunk.js";
};